import { getMessagesByLocale } from '@/locales'

const fetchMessages = (loc) => {
  return getMessagesByLocale(loc)
}

export { fetchMessages }
